const FinalForm =({ostajaData, setOstajaData, finalForm ,scart, Buy,setScart})=>{
    const oowoo = (ev) =>{
        ev.preventDefault()
        let tempObj = {}
        for(let i = 0; i < ev.target.length - 1; i++){
            tempObj[ev.target.elements[i].getAttribute("name")] = ev.target.elements[i].value
        }
        Buy([...scart])
        setOstajaData(tempObj)
        finalForm()
        setScart([])
        console.log(ostajaData)
    }
    return(
        <form onSubmit={oowoo}>
            <label>Nimi</label><br/>
            <input type="text" name="name" required /><br/>
            <label>sähköpostiosoite</label><br/>
            <input type="email" name="email" required/><br/>
            <label>puhelinnumero </label><br/>
            <input type="text" name="puh" required/><br/>
            <hr></hr>
            <label>katuosoite</label><br/>
            <input type="text" name="osoite" required/><br/>
            <label>postinumero</label><br/>
            <input type="text" name="pnum" required/><br/>
            <label>postitoimipaikka</label><br/>
            <input type="text" name="ppaikka" required/><br/>
            <input type="submit" value="Vahvista tilaus" required/>
        </form>
    )
}
export default FinalForm;
